const videoPlay = {
  el: {
    videoTrigger: document.querySelector<HTMLElement>('.video-overlay'),
    videoImage: document.querySelector<HTMLElement>('.video-image'),
    video: document.querySelector<HTMLVideoElement>('.embeditem'),
  },

  init(): void {
    this.handleVideoClick()
  },

  handleVideoClick() {
    if (this.el.videoTrigger) {
      this.el.videoTrigger.addEventListener('click', () => {
        this.el.videoTrigger.classList.add('hidden')
        this.el.videoImage.classList.add('hidden')
      })
    }

    if (this.el.video) {
      this.el.video.addEventListener('click', () => {
        this.el.videoTrigger.classList.remove('hidden')
        this.el.videoImage.classList.remove('hidden')
      })
    }
  },
}

export default videoPlay
